import { render, staticRenderFns } from "./inairrecord.vue?vue&type=template&id=f321e9b0&"
import script from "./inairrecord.vue?vue&type=script&lang=ts&"
export * from "./inairrecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports